import { render, staticRenderFns } from "./images1.vue?vue&type=template&id=0495afc4&scoped=true"
import script from "./images1.vue?vue&type=script&lang=js"
export * from "./images1.vue?vue&type=script&lang=js"
import style0 from "./images1.vue?vue&type=style&index=0&id=0495afc4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0495afc4",
  null
  
)

export default component.exports